<template>
  <div>
    <HeaderComponent
      :pageContent="pageHeader"
       @change_language="handleHeaderClick"
      ></HeaderComponent> 
    <div class="container py-4 my-4">
      <div class="row">
        <div class="col-md-6">
          <h2 style="color: #0c27bd; font-weight: 500">
            {{ pageContent.title }}<br />{{ pageContent.confidence }}
          </h2>
          <img
            src="/assets/images/home-banner/explore.png"
            alt="Explore New Horizons"
            class="img-fluid rounded"
          />
        </div>
        <div class="col-md-4">
          <div class="mb-4">
            <p style="font-size: 18px">
              {{ pageContent.des }}
            </p>
            <!-- Buttons Section -->
            <div class="d-flex flex-wrap gap-3 mt-3">
              <div class="col">
                <router-link :to="'/housing-resources'">
                  <button class="btn btn-primary w-100">
                    {{ pageContent.housing }}
                    
                  </button>
                </router-link>
              </div>
              <div class="col">
                <router-link :to="'/relocation-support'">
                  <button class="btn btn-primary w-100">
                    {{ pageContent.relocation }}
                    
                  </button>
                </router-link>
              </div>
            </div>
            <div class="d-flex flex-wrap gap-3 mt-3">
              <div class="col">
                <router-link to="/financial-resources"
                  ><button class="btn btn-primary w-100">
                    {{ pageContent.financial }}
                    
                  </button>
                </router-link>
              </div>
              <div class="col">
                <router-link to="/community"
                  ><button class="btn btn-primary w-100">
                    {{ pageContent.community }}
                    
                  </button></router-link
                >
              </div>
            </div>
            <br /><br />
            <hr class="mt-4" />
            <p
              class="text-primary text-center text-uppercase"
              style="color: #0c27bd; font-size: 16px"
            >
            {{ pageContent.follow }}
              
            </p>
            <div class="d-flex flex-wrap justify-content-center gap-4">
              <a
                href="https://www.facebook.com/explore2teach"
                target="_blank"
                class="text-blue fs-1"
              >
                <i class="fa-brands fa-facebook"></i>
              </a>
              <a
                href="https://www.instagram.com/explore2teach/"
                target="_blank"
                class="text-danger fs-1"
              >
                <i class="fa-brands fa-instagram"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/explore2teach"
                target="_blank"
                class="text-blue fs-1"
              >
                <i class="fa-brands fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
  name: "AboutUs",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data(){
    return {
      pageContent: [],
      pageHeader:[],
      pageFooter:[],
    }
  },
  mounted() {
    const storedLanguage = localStorage.getItem("language");
  if (storedLanguage) {
    this.language = storedLanguage;
  }
  this.convertLanguage();
  },
  methods: {
    goToRegister() {
      window.location = "/user/register";
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === 'us') {
        lang = 'en';
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.explore[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };
      
        this.pageHeader={
          ...this.pageHeader,
          ...pageHeader,
        }
        this.pageFooter={
          ...this.pageFooter,
          ...pageFooter,
        }
        
      }  
    },
  },
};
</script>